// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachments_uv3NS{
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.attachment_PcrEV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #e2f4f0;
  border-radius: 12px;
  cursor: default;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover{
    border-color: transparent;
    background-color: var(--f4-background);
  }
  .icon_VWSEU{
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: var(--f5-background);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  .content_unbHP{
    display: flex;
    flex-direction: column;
    width: 100%;
    >div{
        display: flex;
        align-items: center;
        width: 100%;
        b {
            font-size: 12px;
            font-weight: 600;
        }
        button {
            background: none;
            border: none;
            cursor: pointer;
            font-size: 12px;
            color: var(--_10a37f-background);
        }
    }
    span {
        font-size: 12px;
        color: var(--_6-color);
    }
    .delete_LZCUJ{
        width: 20px;
        height: 20px;
        background: red;
        border-radius: 50%;
    }
  }
}

.wasImported_RWmUR {
  padding-left: 6px;
  .icon_VWSEU{
    background-color: #ddfff7;
  }
}

.loaderImportConnectionAttachment_oH1v4 {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: relative;
  animation: rotate_clNQZ 1s linear infinite
}
.loaderImportConnectionAttachment_oH1v4::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 2px solid var(--_10a37f-background);
  animation: prixClipFix_J4ZQU 2s linear infinite;
}

@keyframes rotate_clNQZ {
  100%   {transform: rotate(360deg)}
}

@keyframes prixClipFix_J4ZQU {
    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
}

.viewMoreContainer_gTaVx {
  width: 100%;
  margin-top: 4px;
}

.viewMoreButton_jkL58 {
  width: 100%;
  background: var(--_10a37f-background);
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #e2f4f0;
  height: 28px;
  border-radius: 6px;
  &:hover {
    background: #10a37ede;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/AttachmentNotification/AttachmentNotification.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC;IACE,yBAAyB;IACzB,sCAAsC;EACxC;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX;YACI,eAAe;YACf,gBAAgB;QACpB;QACA;YACI,gBAAgB;YAChB,YAAY;YACZ,eAAe;YACf,eAAe;YACf,gCAAgC;QACpC;IACJ;IACA;QACI,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,+CAA0C;AAC5C;;AAEA;EACE,QAAQ,yBAAyB;AACnC;;AAEA;IACI,MAAM,8CAA8C;IACpD,MAAM,0DAA0D;IAChE,MAAM,mEAAmE;IACzE,MAAM,6DAA6D;IACnE,MAAM,0DAA0D;AACpE;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".attachments{\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.attachment {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border: 1px solid #e2f4f0;\n  border-radius: 12px;\n  cursor: default;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  &:hover{\n    border-color: transparent;\n    background-color: var(--f4-background);\n  }\n  .icon{\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n    background: var(--f5-background);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .content{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    >div{\n        display: flex;\n        align-items: center;\n        width: 100%;\n        b {\n            font-size: 12px;\n            font-weight: 600;\n        }\n        button {\n            background: none;\n            border: none;\n            cursor: pointer;\n            font-size: 12px;\n            color: var(--_10a37f-background);\n        }\n    }\n    span {\n        font-size: 12px;\n        color: var(--_6-color);\n    }\n    .delete{\n        width: 20px;\n        height: 20px;\n        background: red;\n        border-radius: 50%;\n    }\n  }\n}\n\n.wasImported {\n  padding-left: 6px;\n  .icon{\n    background-color: #ddfff7;\n  }\n}\n\n.loaderImportConnectionAttachment {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n.loaderImportConnectionAttachment::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 2px solid var(--_10a37f-background);\n  animation: prixClipFix 2s linear infinite ;\n}\n\n@keyframes rotate {\n  100%   {transform: rotate(360deg)}\n}\n\n@keyframes prixClipFix {\n    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}\n    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}\n    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}\n    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}\n    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}\n}\n\n.viewMoreContainer {\n  width: 100%;\n  margin-top: 4px;\n}\n\n.viewMoreButton {\n  width: 100%;\n  background: var(--_10a37f-background);\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #e2f4f0;\n  height: 28px;\n  border-radius: 6px;\n  &:hover {\n    background: #10a37ede;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachments": `attachments_uv3NS`,
	"attachment": `attachment_PcrEV`,
	"icon": `icon_VWSEU`,
	"content": `content_unbHP`,
	"delete": `delete_LZCUJ`,
	"wasImported": `wasImported_RWmUR`,
	"loaderImportConnectionAttachment": `loaderImportConnectionAttachment_oH1v4`,
	"rotate": `rotate_clNQZ`,
	"prixClipFix": `prixClipFix_J4ZQU`,
	"viewMoreContainer": `viewMoreContainer_gTaVx`,
	"viewMoreButton": `viewMoreButton_jkL58`
};
export default ___CSS_LOADER_EXPORT___;
